import { render, staticRenderFns } from "./BriefcaseUpdateModal.vue?vue&type=template&id=6a3f4065&scoped=true"
import script from "./BriefcaseUpdateModal.vue?vue&type=script&lang=js"
export * from "./BriefcaseUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./BriefcaseUpdateModal.vue?vue&type=style&index=0&id=6a3f4065&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3f4065",
  null
  
)

export default component.exports